export const ubigeoState = {
    listado: [],
    isLoading: false,
    message: '',
    severity: '',
}